import React, { useState, useEffect } from 'react';
import BlogPostCard from './BlogPostCard';
import ButtonBlue from '../../Buttons/ButtonBlue';
import config from '../../../config';

const LatestBlogPosts = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    // Replace with the actual API or data source for your blog posts
    fetch(`${config.apiUrl}/blogs`)
      .then(response => response.json())
      .then(data => 
        setPosts(data.slice(0, 3))) // Fetch and display the 3 most recent posts
      .catch(error => console.error('Error fetching blog posts', error));
  }, []);

  return (
    <div className="wrapper-darker">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '0% 4%' }}>
        <h2 className="title-blue">Latest Blog Posts</h2>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'center'}}>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {posts.map(post => (
              <BlogPostCard
                key={post.id}
                title={post.title}
                excerpt={post.content.content[0].text}
                url={`/blog/${post.id}`} // Assuming each post has a unique ID
              />
            ))}
          </div>
        </div>
        <div className="center">
          <ButtonBlue destination={'/blog'} text={'View All Blog Posts'} />
        </div>
      </div>
    </div>
  );
};


export default LatestBlogPosts;